export const PERMISSION_VIEW_STUDENT_INTELLIGENCE = 'ViewStudentIntelligence';

export function canViewStudentIntelligence(permissions, role) {
  if (role === 'SuperAdmin') {
    return true;
  }
  if (!Array.isArray(permissions)) {
    return false;
  }
  return permissions.includes(PERMISSION_VIEW_STUDENT_INTELLIGENCE);
}
